import React, { useEffect, useState, useCallback  } from 'react'
import { Breadcrumb, CardBasic, PaginationCustom, TextInput, ModalForm, ConfirmModal } from '../../components'
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { Jam } from '../../assets';


function Product() {
    const [selectedStatus, setSelectedStatus] = useState({label: 'All',value: 'All'});
    const [searchTerm, setSearchTerm] = useState('');
  
    const [datas, setDatas] = useState([]);
    const [apiData, setApiData] = useState([]);
    const [newData, setNewData] = useState([]);
    const navigate = useNavigate();

    const arr = [
        {label: 'All',value: 'All'},
        {label: 'Inactive',value: 'Inactive'},
        {label: 'Published',value: 'Published'},
        {label: 'Scheduled',value: 'Scheduled'},
    ];

    const handleStatusChange = (selectedOption) => {
        setSelectedStatus(selectedOption);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const normalizeDate = (date) => {
        const normalized = new Date(date);
        normalized.setHours(0, 0, 0, 0);
        return normalized;
    };

    useEffect(() => {
        const fetchData = async () => {
            const res = await fetch('/json/product.json');
            const data = await res.json();

            // Ambil data dari localStorage
            // const localData = JSON.parse(localStorage.getItem('patients')) || [];
            // Gabungkan data dari JSON dan localStorage
            // const combinedData = [...data, ...localData];

            // setDatas(combinedData);
            setApiData(data);
            updateCombinedData(data);
        };
        fetchData();
    },[]);

    const updateCombinedData = (apiData) => {
        const localData = JSON.parse(localStorage.getItem('products')) || [];
        setDatas([...apiData, ...localData]); // Gabungkan API + localStorage
    };

    useEffect(() => {
        if (datas.length > 0) {
            const filterByDateAndStatus = (data) => {

                const filteredData = data.filter((item) => {
                    const statusMatch = selectedStatus.value === 'All' || item.status === selectedStatus.value; // Filter by status
                    const searchMatch = searchTerm.trim() === "" || item.patient.toLowerCase().includes(searchTerm.toLowerCase()); // Filter by search term
                    return statusMatch && searchMatch;
                });

                const sortedData = filteredData.sort((a, b) => {
                    const dateA = new Date(normalizeDate(a.date));
                    const dateB = new Date(normalizeDate(b.date));
                    return dateA - dateB; // Ascending order
                });

                return sortedData;
            };
            
            const filteredAndSortedData  = filterByDateAndStatus(datas);
            setNewData(filteredAndSortedData );
            // if (filteredAndSortedData  !== datas) {
                // setNewData(filteredAndSortedData ); //Berubah jika hanya ada update
            // }
        }
    }, [datas,selectedStatus,searchTerm]);


    const CardTitle = () => {
        return (
            <>
                <div className='card-title'>
                    <div className="d-flex align-items-center position-relative my-1">
                        <i className="ki-outline ki-magnifier fs-3 position-absolute ms-4"></i>
                        <TextInput type={'text'} 
                        clas={'form-control form-control-solid w-250px ps-12'}
                        placeholder={'Search Products...'}
                        value={searchTerm}
                        onChange={handleSearchChange}
                        />
                    </div>
                </div>
                <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>
                    <div className="w-150px">
                        <Select
                            className=""
                            options={arr}
                            placeholder="Status"
                            isSearchable={false}
                            value={selectedStatus}
                            onChange={handleStatusChange}
                        />
                    </div>
                </div>
            </>
        )
    }

    const ListBody = (arr) => {
        const [activeIndex, setActiveIndex] = useState(null);
        const [filteredData, setFilteredData] = useState([]);

        const handlePagination = useCallback((data) => {
            setFilteredData((prevData) => {
                // Hanya setState jika data berbeda
                if (JSON.stringify(prevData) !== JSON.stringify(data)) {
                    return data;
                }
                return prevData;
            });
        }, []);
        
        return (
            <>
                <div className="table-responsive">
                    <table className="table align-middle table-row-dashed fs-6 gy-5">
                        <thead>
                            <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                <th className="min-w-100px">PRODUCT</th>
                                <th className="text-end min-w-100px">SKU</th>
                                <th className="text-end min-w-50px">QTY</th>
                                <th className="text-end min-w-100px">PRICE</th>
                                <th className="text-end min-w-100px">UPDATE DATE</th>
                                <th className="text-end min-w-70px">STATUS</th>
                            </tr>
                        </thead>
                        <tbody className="fw-semibold text-gray-600">
                            {filteredData.map((item, index) => {
                                // Format tanggal dd-mm-yyyy
                                const formatDate = (dateStr) => {
                                if (!dateStr) return '-';
                                    const date = new Date(dateStr);
                                    const day = String(date.getDate()).padStart(2, '0');
                                    const month = String(date.getMonth() + 1).padStart(2, '0');
                                    const year = date.getFullYear();
                                    return `${day}-${month}-${year}`;
                                };

                                return (
                                    <tr key={index}>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <a href={`/product/${item.id || '#'}`} className="symbol symbol-50px">
                                                    <span
                                                    className="symbol-label"
                                                    style={{
                                                        backgroundImage: `url(${item.image_url || Jam})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center'
                                                    }}
                                                    ></span>
                                                </a>
                                                <div className="ms-5">
                                                    {item.name_product}
                                                </div>
                                            </div>
                                        </td>
                                        <td className='text-end'>{item.sku}</td>
                                        <td className='text-end'>{item.quantity}</td>
                                        <td className='text-end'>{item.price}</td>
                                        <td className='text-end'>{formatDate(item.updated_at)}</td>
                                        <td className='text-end'>  
                                            <div className={ item.status === 'Published' ? `badge badge-light-success` : 'badge badge-light-danger' }>
                                                {item.status ? item.status : '-'}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <PaginationCustom
                        data={arr || []}
                        page={10}
                        current={1}
                        onPaginate={handlePagination}
                    />
                </div>
            </>
        )
    }

    return (
        <>
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                <Breadcrumb title={'Home'} header={'Data All Products'}/>
                <div className='app-container container-xxl d-flex'>
                    <div className='app-main flex-column flex-row-fluid' id="kt_app_main">
                        <div className='d-flex flex-column flex-column-fluid'>
                            <div className='app-content'>
                                <CardBasic
                                    className={'card-flush'}
                                    className3={'align-items-center py-5 gap-2 gap-md-5'}
                                    header={CardTitle()}
                                    className2={'pt-0'}
                                    children={ListBody(newData)}
                                />
                            </div>
                        </div>
                        <div className='app-footer d-flex flex-column flex-md-row flex-center flex-md-stack pb-3'>
                            <div className='text-dark order-2 order-md-1'>
                                <span className='text-muted fw-semibold me-1'>2025&copy;</span>
                            </div>
                            <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
                                <li className='menu-item'><span className='menu-link px-2'>About</span></li>
                                <li className='menu-item'><span className='menu-link px-2'>Support</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Product
